import angular from 'angular'

import { toRgb, toPixel } from '../utils/bits'

import { MOBILE_THRESHOLD } from '../utils/shared-constants'

angular
  .module('ggs.gallery-modal-list')
  .factory('GmlStyleHandlers', GmlStyleHandlersProvider)

function GmlStyleHandlersProvider(
  rootQs,
  GSNApplyStyleTmpl) {

  const OWNER_TAG = __filename

  return function GmlStyleHandlers(listQs) {

    // applyBgDesktop
    const BG_DESKTOP_COLOR_PLH = ':bg-desktop-clr:'
    const BG_DESKTOP_OPACITY_PLH = ':bg-desktop-plc:'

    const BG_DESKTOP_TMPL = `
      ${rootQs} ${listQs} .ggs-gml__background {
        background-color: rgba(${BG_DESKTOP_COLOR_PLH}, ${BG_DESKTOP_OPACITY_PLH});
      }`

    const applyBgDesktop = GSNApplyStyleTmpl({
      ownerTag: OWNER_TAG,
      propKeys: [
        'modals_bg_desktop_color',
        'modals_bg_desktop_opacity'
      ],
      allowEmpty: false,
      styleFunc: (modals_bg_desktop_color, modals_bg_desktop_opacity) =>
        BG_DESKTOP_TMPL
          .replace(BG_DESKTOP_COLOR_PLH, toRgb(modals_bg_desktop_color))
          .replace(BG_DESKTOP_OPACITY_PLH, modals_bg_desktop_opacity)
    })

    // applyBgMobile
    const BG_MOBILE_CLR_PLH = ':bg-mobile-clr:'
    const BG_MOBILE_CLR_TMPL = `
      @media (max-width: ${toPixel(MOBILE_THRESHOLD)}), (max-height: ${toPixel(MOBILE_THRESHOLD)}) {
        ${rootQs} ${listQs} .ggs-gml__background {
          background-color: ${BG_MOBILE_CLR_PLH};
        }
      }`

    const applyBgMobile = GSNApplyStyleTmpl({
      ownerTag: OWNER_TAG,
      propKeys: 'modals_bg_mobile_color',
      styleTmpl: BG_MOBILE_CLR_TMPL,
      stylePlh: BG_MOBILE_CLR_PLH
    })

    return [
      applyBgDesktop,
      applyBgMobile
    ]
  }
}
